var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneshopImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 427,
    viewBox: "0 0 678 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2464_137496)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 678,
    height: 427,
    rx: 30,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.087,
    y1: 254.287,
    x2: 624.001,
    y2: 254.287,
    stroke: "#D7D8D9",
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.087,
    y1: 340.392,
    x2: 624.001,
    y2: 340.392,
    stroke: "#3D3D3D",
    strokeOpacity: 0.6,
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251,
    y1: 318.866,
    x2: 623.914,
    y2: 318.866,
    stroke: "#D7D8D9",
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 297.526L623.914 297.526",
    stroke: "#D7D8D9",
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 276L623.914 276",
    stroke: "#D7D8D9",
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.422,
    y: 312.995,
    width: 6.70951,
    height: 27.2108,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.787,
    y: 297.339,
    width: 6.70951,
    height: 42.8663,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.955,
    cy: 300.508,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.152,
    y: 312.995,
    width: 6.33676,
    height: 27.2108,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.145,
    y: 315.231,
    width: 6.70951,
    height: 24.9743,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.51,
    y: 306.286,
    width: 7.08226,
    height: 33.9203,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.246,
    y: 315.231,
    width: 6.33676,
    height: 24.9743,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.238,
    y: 317.095,
    width: 6.70951,
    height: 23.1105,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.604,
    y: 312.995,
    width: 6.70951,
    height: 27.2108,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.969,
    y: 287.275,
    width: 6.33676,
    height: 52.9306,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.961,
    y: 310.759,
    width: 6.70951,
    height: 29.4473,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.326,
    y: 304.049,
    width: 6.70951,
    height: 36.1568,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.878,
    y: 293.798,
    width: 5.96401,
    height: 46.2211,
    fill: "#2E4063",
    stroke: "#2E4063",
    strokeWidth: 0.372751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.684,
    y: 310.759,
    width: 6.70951,
    height: 29.4473,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.049,
    y: 279.82,
    width: 6.33676,
    height: 60.3856,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.041,
    y: 282.802,
    width: 6.33676,
    height: 57.4036,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.033,
    y: 266.774,
    width: 6.70951,
    height: 73.4319,
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.46,
    y1: 315.888,
    x2: 296.825,
    y2: 300.605,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.097,
    y1: 300.241,
    x2: 319.834,
    y2: 316.642,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.563,
    y1: 316.166,
    x2: 341.183,
    y2: 318.403,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.286,
    y1: 318.442,
    x2: 364.024,
    y2: 309.123,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.075,
    y1: 309.123,
    x2: 386.813,
    y2: 318.442,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.649,
    y1: 318.402,
    x2: 408.641,
    y2: 320.266,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.493,
    y1: 320.273,
    x2: 430.858,
    y2: 316.173,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.905,
    y1: 316.362,
    x2: 452.897,
    y2: 290.27,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.736,
    y1: 290.624,
    x2: 475.355,
    y2: 314.107,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.164,
    y1: 313.575,
    x2: 497.529,
    y2: 307.239,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 497.445,
    y1: 307.27,
    x2: 519.81,
    y2: 296.833,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.391,
    y1: 296.898,
    x2: 542.383,
    y2: 314.045,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.582,
    y1: 314.536,
    x2: 563.947,
    y2: 282.853,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.479,
    y1: 282.994,
    x2: 586.472,
    y2: 285.976,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.057,
    y1: 286.458,
    x2: 608.05,
    y2: 269.684,
    stroke: "#30C2B0",
    strokeWidth: 1.11825
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.59,
    cy: 316.164,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.32,
    cy: 316.164,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.312,
    cy: 318.4,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.051,
    cy: 309.454,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.416,
    cy: 318.4,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.408,
    cy: 320.264,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.773,
    cy: 316.163,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.137,
    cy: 290.443,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.129,
    cy: 313.927,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.494,
    cy: 307.217,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.859,
    cy: 296.78,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.852,
    cy: 313.927,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.217,
    cy: 282.988,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.209,
    cy: 285.97,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.201,
    cy: 269.942,
    r: 1.30463,
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2464_137496)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-54-outside-1_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 519,
    y: 78,
    width: 29,
    height: 30,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 519,
    y: 78,
    width: 29,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.627 83.8754C529.099 80.6967 538.068 79.0463 547.117 79.001L547.237 102.869C541.011 102.9 534.84 104.035 529.011 106.222L520.627 83.8754Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520.627 83.8754C529.099 80.6967 538.068 79.0463 547.117 79.001L547.237 102.869C541.011 102.9 534.84 104.035 529.011 106.222L520.627 83.8754Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.627 83.8754C529.099 80.6967 538.068 79.0463 547.117 79.001L547.237 102.869C541.011 102.9 534.84 104.035 529.011 106.222L520.627 83.8754Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-54-outside-1_2464_137496)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-55-outside-2_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 499,
    y: 83,
    width: 31,
    height: 32,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 499,
    y: 83,
    width: 31,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.523 95.123C506.524 90.4537 513.188 86.7052 520.294 84.0011L528.782 106.309C523.893 108.169 519.308 110.748 515.18 113.961L500.523 95.123Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.523 95.123C506.524 90.4537 513.188 86.7052 520.294 84.0011L528.782 106.309C523.893 108.169 519.308 110.748 515.18 113.961L500.523 95.123Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.523 95.123C506.524 90.4537 513.188 86.7052 520.294 84.0011L528.782 106.309C523.893 108.169 519.308 110.748 515.18 113.961L500.523 95.123Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-55-outside-2_2464_137496)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-56-outside-3_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 475,
    y: 94,
    width: 42,
    height: 43,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 475,
    y: 94,
    width: 42,
    height: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.457 127.124C481.491 114.521 489.787 103.485 500.493 95.1458L515.159 113.976C507.793 119.713 502.086 127.307 498.623 135.977L476.457 127.124Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.457 127.124C481.491 114.521 489.787 103.485 500.493 95.1458L515.159 113.976C507.793 119.713 502.086 127.307 498.623 135.977L476.457 127.124Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.457 127.124C481.491 114.521 489.787 103.485 500.493 95.1458L515.159 113.976C507.793 119.713 502.086 127.307 498.623 135.977L476.457 127.124Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-56-outside-3_2464_137496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-57-outside-4_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 470,
    y: 126,
    width: 30,
    height: 30,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 470,
    y: 126,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.001 155.11C471.049 145.651 472.851 136.282 476.316 127.48L498.526 136.222C496.142 142.278 494.902 148.724 494.869 155.232L471.001 155.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471.001 155.11C471.049 145.651 472.851 136.282 476.316 127.48L498.526 136.222C496.142 142.278 494.902 148.724 494.869 155.232L471.001 155.11Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.001 155.11C471.049 145.651 472.851 136.282 476.316 127.48L498.526 136.222C496.142 142.278 494.902 148.724 494.869 155.232L471.001 155.11Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-57-outside-4_2464_137496)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-58-outside-5_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 470,
    y: 154,
    width: 33,
    height: 40,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 470,
    y: 154,
    width: 33,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 155.5C471 168.395 474.26 181.081 480.476 192.379L501.388 180.873C497.111 173.1 494.868 164.372 494.868 155.5H471Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M471 155.5C471 168.395 474.26 181.081 480.476 192.379L501.388 180.873C497.111 173.1 494.868 164.372 494.868 155.5H471Z",
    fill: "#BDA4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 155.5C471 168.395 474.26 181.081 480.476 192.379L501.388 180.873C497.111 173.1 494.868 164.372 494.868 155.5H471Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-58-outside-5_2464_137496)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-59-outside-6_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 479,
    y: 180,
    width: 37,
    height: 37,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 479,
    y: 180,
    width: 37,
    height: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.657 192.706C485.516 201.435 492.038 209.128 499.854 215.351L514.72 196.677C509.342 192.396 504.855 187.104 501.512 181.098L480.657 192.706Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M480.657 192.706C485.516 201.435 492.038 209.128 499.854 215.351L514.72 196.677C509.342 192.396 504.855 187.104 501.512 181.098L480.657 192.706Z",
    fill: "#BDA4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.657 192.706C485.516 201.435 492.038 209.128 499.854 215.351L514.72 196.677C509.342 192.396 504.855 187.104 501.512 181.098L480.657 192.706Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-59-outside-6_2464_137496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-60-outside-7_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 499,
    y: 195,
    width: 50,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 499,
    y: 195,
    width: 50,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.024 215.486C513.463 226.122 530.084 231.937 547.223 231.999L547.309 208.132C535.518 208.089 524.082 204.088 514.836 196.77L500.024 215.486Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.024 215.486C513.463 226.122 530.084 231.937 547.223 231.999L547.309 208.132C535.518 208.089 524.082 204.088 514.836 196.77L500.024 215.486Z",
    fill: "#BDA4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.024 215.486C513.463 226.122 530.084 231.937 547.223 231.999L547.309 208.132C535.518 208.089 524.082 204.088 514.836 196.77L500.024 215.486Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-60-outside-7_2464_137496)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-61-outside-8_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 589,
    y: 155,
    width: 36,
    height: 46,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 589,
    y: 155,
    width: 36,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.382 199.067C619.17 186.384 623.916 171.339 623.999 155.909L600.131 155.781C600.075 166.397 596.809 176.748 590.763 185.474L610.382 199.067Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M610.382 199.067C619.17 186.384 623.916 171.339 623.999 155.909L600.131 155.781C600.075 166.397 596.809 176.748 590.763 185.474L610.382 199.067Z",
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.382 199.067C619.17 186.384 623.916 171.339 623.999 155.909L600.131 155.781C600.075 166.397 596.809 176.748 590.763 185.474L610.382 199.067Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-61-outside-8_2464_137496)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-62-outside-9_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 546,
    y: 184,
    width: 66,
    height: 49,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 546,
    y: 184,
    width: 66,
    height: 49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.5 232C559.796 232 571.91 229.036 582.817 223.36C593.724 217.683 603.102 209.462 610.156 199.391L590.608 185.697C585.754 192.626 579.302 198.282 571.798 202.188C564.294 206.093 555.959 208.132 547.5 208.132V232Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M547.5 232C559.796 232 571.91 229.036 582.817 223.36C593.724 217.683 603.102 209.462 610.156 199.391L590.608 185.697C585.754 192.626 579.302 198.282 571.798 202.188C564.294 206.093 555.959 208.132 547.5 208.132V232Z",
    fill: "#30C2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.5 232C559.796 232 571.91 229.036 582.817 223.36C593.724 217.683 603.102 209.462 610.156 199.391L590.608 185.697C585.754 192.626 579.302 198.282 571.798 202.188C564.294 206.093 555.959 208.132 547.5 208.132V232Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-62-outside-9_2464_137496)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-63-outside-10_2464_137496",
    maskUnits: "userSpaceOnUse",
    x: 546,
    y: 78,
    width: 79,
    height: 79,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 546,
    y: 78,
    width: 79,
    height: 79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 155.5C624 145.454 622.021 135.506 618.177 126.225C614.332 116.943 608.697 108.51 601.594 101.406C594.49 94.3026 586.057 88.6677 576.775 84.8232C567.494 80.9787 557.546 79 547.5 79V102.868C554.412 102.868 561.256 104.229 567.641 106.874C574.027 109.519 579.829 113.396 584.716 118.284C589.604 123.171 593.481 128.973 596.126 135.359C598.771 141.744 600.132 148.588 600.132 155.5H624Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M624 155.5C624 145.454 622.021 135.506 618.177 126.225C614.332 116.943 608.697 108.51 601.594 101.406C594.49 94.3026 586.057 88.6677 576.775 84.8232C567.494 80.9787 557.546 79 547.5 79V102.868C554.412 102.868 561.256 104.229 567.641 106.874C574.027 109.519 579.829 113.396 584.716 118.284C589.604 123.171 593.481 128.973 596.126 135.359C598.771 141.744 600.132 148.588 600.132 155.5H624Z",
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 155.5C624 145.454 622.021 135.506 618.177 126.225C614.332 116.943 608.697 108.51 601.594 101.406C594.49 94.3026 586.057 88.6677 576.775 84.8232C567.494 80.9787 557.546 79 547.5 79V102.868C554.412 102.868 561.256 104.229 567.641 106.874C574.027 109.519 579.829 113.396 584.716 118.284C589.604 123.171 593.481 128.973 596.126 135.359C598.771 141.744 600.132 148.588 600.132 155.5H624Z",
    stroke: "white",
    strokeWidth: 1.39091,
    mask: "url(#path-63-outside-10_2464_137496)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 80,
    width: 159,
    height: 152,
    rx: 14.1956,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 213,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 219.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 188,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 194.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 188,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 194.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 188,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 194.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 193,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 166,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    y1: 205.814,
    x2: 427.675,
    y2: 205.814,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.316,
    y1: 105.341,
    x2: 427.991,
    y2: 105.341,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.316,
    y1: 131.208,
    x2: 427.991,
    y2: 131.208,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    y1: 155.814,
    x2: 427.675,
    y2: 155.814,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    y1: 180.814,
    x2: 427.675,
    y2: 180.814,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 93.1956C269 85.3556 275.356 79 283.196 79H414.11C421.95 79 428.306 85.3556 428.306 93.1956V105.498H269V93.1956Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.158,
    y1: 79,
    x2: 309.158,
    y2: 232,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.158,
    y1: 79,
    x2: 348.158,
    y2: 232,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.158,
    y1: 79,
    x2: 389.158,
    y2: 232,
    stroke: "#A1AEBD",
    strokeWidth: 0.315457
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.994,
    y: 89.7915,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.994,
    y: 137.633,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.482,
    y: 137.633,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.482,
    y: 112.813,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 112.813,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.338,
    y: 112.813,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.994,
    y: 144.108,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.482,
    y: 144.108,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 163,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 169.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.482,
    y: 119.288,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 119.288,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.338,
    y: 119.288,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.482,
    y: 89.7915,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 89.7915,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.338,
    y: 89.7915,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.957,
    y: 114.612,
    width: 24.4604,
    height: 5.03597,
    rx: 2.51799,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 213,
    width: 24.4604,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 219.475,
    width: 14.3885,
    height: 3.59712,
    rx: 1.79856,
    fill: "#A1AEBD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.158,
    y1: 79,
    x2: 181.158,
    y2: 341,
    stroke: "#A1AEBD",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1583,
    y1: 79,
    x2: 80.1583,
    y2: 341,
    stroke: "#A1AEBD",
    strokeWidth: 0.316618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2715 194.891C80.2715 192.002 82.6131 189.661 85.5017 189.661H146.621V200.121H85.5017C82.6131 200.121 80.2715 197.779 80.2715 194.891Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.621,
    y: 189.661,
    width: 47.3922,
    height: 10.4605,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.149 189.661H213.769C216.658 189.661 219 192.002 219 194.891C219 197.779 216.658 200.121 213.769 200.121H193.149V189.661Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 170.23C80 167.342 82.3417 165 85.2302 165H135.001V175.46H85.2302C82.3417 175.46 80 173.119 80 170.23Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 165,
    width: 39.2861,
    height: 10.4605,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57 165H189.769C192.657 165 194.999 167.342 194.999 170.23C194.999 173.119 192.657 175.46 189.769 175.46H173.57V165Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9375 265.839H137.389V274.651H92.9375V265.839Z",
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.926 265.839H217.98C220.413 265.839 222.386 267.812 222.386 270.245C222.386 272.678 220.413 274.651 217.98 274.651H135.926V265.839Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4629 274.652L73.407 274.652C70.9736 274.652 69.0009 272.68 69.0009 270.246C69.0009 267.813 70.9736 265.84 73.407 265.84L95.4629 265.84L95.4629 274.652Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 220.073C102 217.371 104.19 215.181 106.892 215.181H173.476V224.964H106.892C104.19 224.964 102 222.774 102 220.073Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.345,
    y: 215.181,
    width: 51.7993,
    height: 9.78372,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.502 215.181H246.108C248.81 215.181 251 217.371 251 220.073C251 222.774 248.81 224.964 246.108 224.964H223.502V215.181Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1875 295.987C80.1875 293.327 82.3441 291.17 85.0044 291.17H139.81V300.804H85.0044C82.3441 300.804 80.1875 298.647 80.1875 295.987Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.496,
    y: 291.17,
    width: 41.9564,
    height: 9.63384,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.24 291.17H185.61C188.27 291.17 190.427 293.327 190.427 295.987C190.427 298.647 188.27 300.804 185.61 300.804H181.24V291.17Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1875 245.159C80.1875 242.592 82.2689 240.51 84.8364 240.51H130.26V249.808H84.8364C82.2689 249.808 80.1875 247.727 80.1875 245.159Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.363,
    y: 240.51,
    width: 62.7382,
    height: 9.29786,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.227 240.511H179.918C182.485 240.511 184.567 242.592 184.567 245.16C184.567 247.727 182.485 249.809 179.918 249.809H165.227V240.511Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 321.727C55 318.84 57.3405 316.5 60.2277 316.5H147.367V326.955H60.2277C57.3405 326.955 55 324.615 55 321.727Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.879,
    y: 316.5,
    width: 64.9987,
    height: 10.4554,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.133 316.5C213.227 316.5 214.926 318.198 214.926 320.293V323.162C214.926 325.257 213.227 326.955 211.133 326.955V316.5Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 148.691C60 145.802 62.3417 143.46 65.2302 143.46H124.088V153.921H65.2302C62.3417 153.921 60 151.579 60 148.691Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 143.46,
    width: 45.7769,
    height: 10.4605,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 143.46H188.77C191.659 143.46 194 145.802 194 148.691C194 151.579 191.659 153.921 188.77 153.921H169.031V143.46Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 124.23C80 121.342 82.3417 119 85.2302 119H117.305V129.46H85.2302C82.3417 129.46 80 127.119 80 124.23Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.305,
    y: 119,
    width: 26.6462,
    height: 10.4605,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.465 119H152.769C155.658 119 157.999 121.342 157.999 124.23C157.999 127.119 155.658 129.46 152.769 129.46H143.465V119Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 100.23C73 97.3417 75.3417 95 78.2302 95H144.262V105.46H78.2302C75.3416 105.46 73 103.119 73 100.23Z",
    fill: "#2E4063"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.262,
    y: 95,
    width: 50.9012,
    height: 10.4605,
    fill: "#3C6DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.235 95H216.769C219.658 95 222 97.3417 222 100.23C222 103.119 219.658 105.46 216.769 105.46H194.235V95Z",
    fill: "#51DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.038 161.69C456.038 229.375 401.147 284.19 333.513 284.19C265.872 284.19 211 229.375 211 161.69C211 93.9807 265.872 39.1904 333.513 39.1904C401.147 39.1904 456.038 93.9807 456.038 161.69Z",
    fill: "#AEE8FD",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.866 359.354C559.269 365.222 552.971 368.441 550.775 366.532L424.833 257.379C422.644 255.477 425.381 249.168 430.979 243.276C436.566 237.408 442.893 234.172 445.08 236.094L571.012 345.251C573.195 347.151 570.449 353.488 564.871 359.367",
    fill: "#243438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.453 258.943C346.438 261.923 361.929 261.126 376.529 256.625C391.129 252.123 404.379 244.059 415.084 233.158C450.781 196.858 450.301 138.477 413.992 102.771C413.352 102.142 412.623 101.595 411.966 100.983C445.018 196.361 363.822 247.068 331.453 258.943Z",
    fill: "#27A8E0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.347 111.705C484.927 180.026 451.9 257.768 383.579 285.348C315.258 312.927 237.516 279.9 209.937 211.579C182.357 143.259 215.385 65.5163 283.705 37.9369C352.026 10.3576 429.768 43.3848 457.347 111.705ZM222.942 206.329C247.622 267.467 317.191 297.023 378.329 272.343C439.467 247.663 469.023 178.093 444.343 116.955C419.663 55.8171 350.093 26.2619 288.955 50.9419C227.817 75.6219 198.262 145.191 222.942 206.329Z",
    fill: "#243438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2464_137496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 678,
    height: 427,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2464_137496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 153,
    fill: "white",
    transform: "translate(471 79)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneshopImg);
export default __webpack_public_path__ + "static/media/OneshopImg.abc8d638.svg";
export { ForwardRef as ReactComponent };